import { render, staticRenderFns } from "./DeactivateBasicUser.vue?vue&type=template&id=46407b84&scoped=true&"
import script from "./DeactivateBasicUser.vue?vue&type=script&lang=js&"
export * from "./DeactivateBasicUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateBasicUser.vue?vue&type=style&index=0&id=46407b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46407b84",
  null
  
)

export default component.exports